/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Viewoptions_Togglecolumns2Inputs */

const id_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alihkan kolom`)
};

const ms_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Togol lajur`)
};

const da_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skift kolonner`)
};

const de_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spalten umschalten`)
};

const en_us2_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle columns`)
};

const es_es2_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar columnas`)
};

const es_mx2_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar columnas`)
};

const fil_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-toggle ang mga column`)
};

const fr_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher/masquer les colonnes`)
};

const it_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva colonne`)
};

const hu_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oszlopok ki/be`)
};

const nl_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolommen in-/uitschakelen`)
};

const no_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slå kolonner av/på`)
};

const pl_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przełącz kolumny`)
};

const pt_br2_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle columns`)
};

const pt_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar colunas`)
};

const ro_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comută coloanele`)
};

const fi_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihda sarakkeita`)
};

const sv_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Växla kolumner`)
};

const vi_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển đổi cột`)
};

const tr_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sütunları aç/kapa`)
};

const cs_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepnout sloupce`)
};

const bg_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Превключване на колони`)
};

const ru_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить колонки`)
};

const uk_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемкнути колонки`)
};

const ar_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبديل الأعمدة`)
};

const hi_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉलम टॉगल करें`)
};

const th_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด/ปิดคอลัมน์`)
};

const ja_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`列の表示切替`)
};

const zh_cn2_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle columns`)
};

const zh_hant1_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle columns`)
};

const ko_table_viewoptions_togglecolumns2 = /** @type {(inputs: Table_Viewoptions_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle columns`)
};

/**
* | output |
* | --- |
* | "Toggle columns" |
*
* @param {Table_Viewoptions_Togglecolumns2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_viewoptions_togglecolumns2 = /** @type {((inputs?: Table_Viewoptions_Togglecolumns2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Viewoptions_Togglecolumns2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_viewoptions_togglecolumns2(inputs)
	if (locale === "ms") return ms_table_viewoptions_togglecolumns2(inputs)
	if (locale === "da") return da_table_viewoptions_togglecolumns2(inputs)
	if (locale === "de") return de_table_viewoptions_togglecolumns2(inputs)
	if (locale === "en-US") return en_us2_table_viewoptions_togglecolumns2(inputs)
	if (locale === "es-ES") return es_es2_table_viewoptions_togglecolumns2(inputs)
	if (locale === "es-MX") return es_mx2_table_viewoptions_togglecolumns2(inputs)
	if (locale === "fil") return fil_table_viewoptions_togglecolumns2(inputs)
	if (locale === "fr") return fr_table_viewoptions_togglecolumns2(inputs)
	if (locale === "it") return it_table_viewoptions_togglecolumns2(inputs)
	if (locale === "hu") return hu_table_viewoptions_togglecolumns2(inputs)
	if (locale === "nl") return nl_table_viewoptions_togglecolumns2(inputs)
	if (locale === "no") return no_table_viewoptions_togglecolumns2(inputs)
	if (locale === "pl") return pl_table_viewoptions_togglecolumns2(inputs)
	if (locale === "pt-BR") return pt_br2_table_viewoptions_togglecolumns2(inputs)
	if (locale === "pt") return pt_table_viewoptions_togglecolumns2(inputs)
	if (locale === "ro") return ro_table_viewoptions_togglecolumns2(inputs)
	if (locale === "fi") return fi_table_viewoptions_togglecolumns2(inputs)
	if (locale === "sv") return sv_table_viewoptions_togglecolumns2(inputs)
	if (locale === "vi") return vi_table_viewoptions_togglecolumns2(inputs)
	if (locale === "tr") return tr_table_viewoptions_togglecolumns2(inputs)
	if (locale === "cs") return cs_table_viewoptions_togglecolumns2(inputs)
	if (locale === "bg") return bg_table_viewoptions_togglecolumns2(inputs)
	if (locale === "ru") return ru_table_viewoptions_togglecolumns2(inputs)
	if (locale === "uk") return uk_table_viewoptions_togglecolumns2(inputs)
	if (locale === "ar") return ar_table_viewoptions_togglecolumns2(inputs)
	if (locale === "hi") return hi_table_viewoptions_togglecolumns2(inputs)
	if (locale === "th") return th_table_viewoptions_togglecolumns2(inputs)
	if (locale === "ja") return ja_table_viewoptions_togglecolumns2(inputs)
	if (locale === "zh-CN") return zh_cn2_table_viewoptions_togglecolumns2(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_viewoptions_togglecolumns2(inputs)
	return ko_table_viewoptions_togglecolumns2(inputs)
});
export { table_viewoptions_togglecolumns2 as "table.viewOptions.toggleColumns" }